// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ScanPage  Security Guard Interface */

.scan-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
}

.scan-header {
  text-align: center;
  margin-bottom: 2rem;
}

.scan-header h1 { display: none; }

.occupancy-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 24px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 30px;
  font-size: 0.92rem;
  color: #334155;
}

.occupancy-badge strong {
  font-size: 1.3rem;
  font-weight: 800;
  color: #3b82f6;
}

/* Mode toggle */
.scan-mode-toggle {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  background: #f1f5f9;
  border-radius: 12px;
  padding: 4px;
}

.mode-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border: none;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  background: transparent;
  color: #64748b;
  transition: all 0.2s;
}

.mode-btn.active {
  background: #fff;
  color: #1e293b;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}

/* Camera area */
.scan-camera-area {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 32px 24px;
  text-align: center;
  max-width: 520px;
  width: 100%;
}

.qr-reader-container {
  margin: 0 auto;
  max-width: 100%;
}

/* html5-qrcode overrides for cleaner look */
#qr-reader { border: none !important; }
#qr-reader__scan_region { border-radius: 12px; overflow: hidden; }
#qr-reader__dashboard { margin-top: 12px; }
#qr-reader__dashboard_section_csr button {
  background: linear-gradient(135deg, #3b82f6, #2563eb) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 10px 20px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
}
#qr-reader__camera_permission_button {
  background: linear-gradient(135deg, #3b82f6, #2563eb) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 12px 24px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  cursor: pointer !important;
}

.scan-area {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 48px 40px;
  text-align: center;
  max-width: 500px;
  width: 100%;
}

.scan-instructions { color: #64748b; font-size: 0.92rem; margin-bottom: 24px; }

.scan-input {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1.1rem;
  text-align: center;
  margin-bottom: 20px;
}

.scan-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59,130,246,0.1);
}

.btn-scan {
  width: 100%;
  padding: 18px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
}

.btn-scan:hover:not(:disabled) {
  box-shadow: 0 8px 20px rgba(37,99,235,0.3);
}

.btn-scan:disabled { opacity: 0.5; cursor: not-allowed; }

.scan-actions {
  margin-top: 24px;
  width: 100%;
  max-width: 520px;
}

.scan-actions .btn-secondary {
  width: 100%;
  padding: 18px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
}

.scan-result-fullscreen {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.scan-result-content { text-align: center; }
.scan-result-icon-svg { margin-bottom: 16px; }
.scan-result-label { font-size: 2rem; font-weight: 800; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 16px; }
.scan-result-name { font-size: 1.5rem; font-weight: 600; opacity: 0.9; }
.scan-result-type { font-size: 1.1rem; opacity: 0.7; margin-top: 8px; text-transform: capitalize; }
.scan-result-vip-badge {
  display: inline-block;
  background: rgba(255,255,255,0.25);
  border: 2px solid rgba(255,255,255,0.5);
  border-radius: 30px;
  padding: 4px 20px;
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: 2px;
  margin-bottom: 12px;
}

.scan-result-dismiss {
  margin-top: 40px;
  padding: 18px 40px;
  background: rgba(255,255,255,0.2);
  border: 2px solid rgba(255,255,255,0.3);
  border-radius: 12px;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
}

.scan-result-dismiss:hover { background: rgba(255,255,255,0.3); }

.scan-input {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1.1rem;
  text-align: center;
  margin-bottom: 20px;
}

.scan-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59,130,246,0.1);
}

.btn-scan {
  width: 100%;
  padding: 18px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
}

.btn-scan:hover:not(:disabled) {
  box-shadow: 0 8px 20px rgba(37,99,235,0.3);
}

.btn-scan:disabled { opacity: 0.5; cursor: not-allowed; }

.scan-actions {
  margin-top: 24px;
  width: 100%;
  max-width: 500px;
}

.scan-actions .btn-secondary {
  width: 100%;
  padding: 18px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
}

.scan-result-fullscreen {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.scan-result-content { text-align: center; }
.scan-result-icon-svg { margin-bottom: 16px; }
.scan-result-label { font-size: 2rem; font-weight: 800; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 16px; }
.scan-result-name { font-size: 1.5rem; font-weight: 600; opacity: 0.9; }
.scan-result-type { font-size: 1.1rem; opacity: 0.7; margin-top: 8px; text-transform: capitalize; }
.scan-result-vip-badge {
  display: inline-block;
  background: rgba(255,255,255,0.25);
  border: 2px solid rgba(255,255,255,0.5);
  border-radius: 30px;
  padding: 4px 20px;
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: 2px;
  margin-bottom: 12px;
}

.scan-result-dismiss {
  margin-top: 40px;
  padding: 18px 40px;
  background: rgba(255,255,255,0.2);
  border: 2px solid rgba(255,255,255,0.3);
  border-radius: 12px;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
}

.scan-result-dismiss:hover { background: rgba(255,255,255,0.3); }
`, "",{"version":3,"sources":["webpack://./src/styles/ScanPage.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,kBAAkB,aAAa,EAAE;;AAEjC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,4CAA4C;AAC5C,aAAa,uBAAuB,EAAE;AACtC,0BAA0B,mBAAmB,EAAE,gBAAgB,EAAE;AACjE,wBAAwB,gBAAgB,EAAE;AAC1C;EACE,gEAAgE;EAChE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,gEAAgE;EAChE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,qBAAqB,cAAc,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;;AAE9E;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,qBAAqB,YAAY,EAAE,mBAAmB,EAAE;;AAExD;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,uBAAuB,kBAAkB,EAAE;AAC3C,wBAAwB,mBAAmB,EAAE;AAC7C,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAC7H,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE,YAAY,EAAE;AACvE,oBAAoB,iBAAiB,EAAE,YAAY,EAAE,eAAe,EAAE,0BAA0B,EAAE;AAClG;EACE,qBAAqB;EACrB,kCAAkC;EAClC,uCAAuC;EACvC,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,6BAA6B,iCAAiC,EAAE;;AAEhE;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,qBAAqB,YAAY,EAAE,mBAAmB,EAAE;;AAExD;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,uBAAuB,kBAAkB,EAAE;AAC3C,wBAAwB,mBAAmB,EAAE;AAC7C,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAC7H,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE,YAAY,EAAE;AACvE,oBAAoB,iBAAiB,EAAE,YAAY,EAAE,eAAe,EAAE,0BAA0B,EAAE;AAClG;EACE,qBAAqB;EACrB,kCAAkC;EAClC,uCAAuC;EACvC,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,6BAA6B,iCAAiC,EAAE","sourcesContent":["/* ScanPage  Security Guard Interface */\n\n.scan-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 2rem;\n}\n\n.scan-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.scan-header h1 { display: none; }\n\n.occupancy-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 24px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 30px;\n  font-size: 0.92rem;\n  color: #334155;\n}\n\n.occupancy-badge strong {\n  font-size: 1.3rem;\n  font-weight: 800;\n  color: #3b82f6;\n}\n\n/* Mode toggle */\n.scan-mode-toggle {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n  background: #f1f5f9;\n  border-radius: 12px;\n  padding: 4px;\n}\n\n.mode-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 24px;\n  border: none;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  background: transparent;\n  color: #64748b;\n  transition: all 0.2s;\n}\n\n.mode-btn.active {\n  background: #fff;\n  color: #1e293b;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.1);\n}\n\n/* Camera area */\n.scan-camera-area {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 32px 24px;\n  text-align: center;\n  max-width: 520px;\n  width: 100%;\n}\n\n.qr-reader-container {\n  margin: 0 auto;\n  max-width: 100%;\n}\n\n/* html5-qrcode overrides for cleaner look */\n#qr-reader { border: none !important; }\n#qr-reader__scan_region { border-radius: 12px; overflow: hidden; }\n#qr-reader__dashboard { margin-top: 12px; }\n#qr-reader__dashboard_section_csr button {\n  background: linear-gradient(135deg, #3b82f6, #2563eb) !important;\n  color: #fff !important;\n  border: none !important;\n  border-radius: 8px !important;\n  padding: 10px 20px !important;\n  font-weight: 600 !important;\n  cursor: pointer !important;\n}\n#qr-reader__camera_permission_button {\n  background: linear-gradient(135deg, #3b82f6, #2563eb) !important;\n  color: #fff !important;\n  border: none !important;\n  border-radius: 8px !important;\n  padding: 12px 24px !important;\n  font-size: 1rem !important;\n  font-weight: 600 !important;\n  cursor: pointer !important;\n}\n\n.scan-area {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 48px 40px;\n  text-align: center;\n  max-width: 500px;\n  width: 100%;\n}\n\n.scan-instructions { color: #64748b; font-size: 0.92rem; margin-bottom: 24px; }\n\n.scan-input {\n  width: 100%;\n  padding: 16px 20px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.scan-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59,130,246,0.1);\n}\n\n.btn-scan {\n  width: 100%;\n  padding: 18px;\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  font-size: 1.05rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.btn-scan:hover:not(:disabled) {\n  box-shadow: 0 8px 20px rgba(37,99,235,0.3);\n}\n\n.btn-scan:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.scan-actions {\n  margin-top: 24px;\n  width: 100%;\n  max-width: 520px;\n}\n\n.scan-actions .btn-secondary {\n  width: 100%;\n  padding: 18px;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.scan-result-fullscreen {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n\n.scan-result-content { text-align: center; }\n.scan-result-icon-svg { margin-bottom: 16px; }\n.scan-result-label { font-size: 2rem; font-weight: 800; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 16px; }\n.scan-result-name { font-size: 1.5rem; font-weight: 600; opacity: 0.9; }\n.scan-result-type { font-size: 1.1rem; opacity: 0.7; margin-top: 8px; text-transform: capitalize; }\n.scan-result-vip-badge {\n  display: inline-block;\n  background: rgba(255,255,255,0.25);\n  border: 2px solid rgba(255,255,255,0.5);\n  border-radius: 30px;\n  padding: 4px 20px;\n  font-size: 1.1rem;\n  font-weight: 800;\n  letter-spacing: 2px;\n  margin-bottom: 12px;\n}\n\n.scan-result-dismiss {\n  margin-top: 40px;\n  padding: 18px 40px;\n  background: rgba(255,255,255,0.2);\n  border: 2px solid rgba(255,255,255,0.3);\n  border-radius: 12px;\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.scan-result-dismiss:hover { background: rgba(255,255,255,0.3); }\n\n.scan-input {\n  width: 100%;\n  padding: 16px 20px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.scan-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59,130,246,0.1);\n}\n\n.btn-scan {\n  width: 100%;\n  padding: 18px;\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  font-size: 1.05rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.btn-scan:hover:not(:disabled) {\n  box-shadow: 0 8px 20px rgba(37,99,235,0.3);\n}\n\n.btn-scan:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.scan-actions {\n  margin-top: 24px;\n  width: 100%;\n  max-width: 500px;\n}\n\n.scan-actions .btn-secondary {\n  width: 100%;\n  padding: 18px;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.scan-result-fullscreen {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n\n.scan-result-content { text-align: center; }\n.scan-result-icon-svg { margin-bottom: 16px; }\n.scan-result-label { font-size: 2rem; font-weight: 800; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 16px; }\n.scan-result-name { font-size: 1.5rem; font-weight: 600; opacity: 0.9; }\n.scan-result-type { font-size: 1.1rem; opacity: 0.7; margin-top: 8px; text-transform: capitalize; }\n.scan-result-vip-badge {\n  display: inline-block;\n  background: rgba(255,255,255,0.25);\n  border: 2px solid rgba(255,255,255,0.5);\n  border-radius: 30px;\n  padding: 4px 20px;\n  font-size: 1.1rem;\n  font-weight: 800;\n  letter-spacing: 2px;\n  margin-bottom: 12px;\n}\n\n.scan-result-dismiss {\n  margin-top: 40px;\n  padding: 18px 40px;\n  background: rgba(255,255,255,0.2);\n  border: 2px solid rgba(255,255,255,0.3);\n  border-radius: 12px;\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.scan-result-dismiss:hover { background: rgba(255,255,255,0.3); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
